import { HtmlMain } from 'htmlmodule'
import './Main.css'

export class Main extends HtmlMain
{
  static class = 'Main'
}
